import { createSlice } from '@reduxjs/toolkit';

import { getVendorInwardedBoxes, getQcModal, getReviewCommentMeta } from '../../apis';

export const VendorQCPlatform = createSlice({

    name: 'vendorQCPlatform',
    initialState: {
        loading: '',
        error: '',
        qcData: [],
        inwardSuccess: '',
        getQcModalData: [],
        getQcModalSuccess: false,
        getReviewCommentMetaData: [],

    },
    reducers: {
        clearInwardSuccess: (state, action) => {
            return {
                ...state,
                inwardSuccess: action.payload
            }
        },
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearGetReviewCommentMetaData: (state, action) => {
            return {
                ...state, 
                getReviewCommentMetaData: action.payload
            }
        },
        clearGetQcModalData: (state, action) => {
            return {
                ...state, 
                getQcModalData: action.payload
            }
        },
        clearGetQcModalSuccess: (state, action) => {
            return {
                ...state, 
                getQcModalSuccess: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getVendorInwardedBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getVendorInwardedBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.qcData = action.payload.data
        })
        builder.addCase(getVendorInwardedBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getQcModal.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getQcModal.fulfilled, (state, action) => {
            state.loading = false;
            state.getQcModalData = action.payload.data
            state.getQcModalSuccess = true
        })
        builder.addCase(getQcModal.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(getReviewCommentMeta.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getReviewCommentMeta.fulfilled, (state, action) => {
            state.loading = false;
            state.getReviewCommentMetaData = action.payload
            state.error = false
        })
        builder.addCase(getReviewCommentMeta.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }

})

export const {clearInwardSuccess, clearError, clearGetReviewCommentMetaData, clearGetQcModalData, clearGetQcModalSuccess, clear} = VendorQCPlatform.actions

export default VendorQCPlatform.reducer